<template>
  <div class="kekkin">
    <h3>欠勤申請</h3>
    <div class="col-item">
      <b class="title">欠勤日</b>
      <p>{{ kekkin?.start_date }}</p>
    </div>
    
    <div class="col-item">
      <b class="title">就業場所</b>
      <p>{{ form.syuugyou_basyo_name }}</p>
    </div>

    <div class="col-item">
      <b class="title">欠勤事由</b>
      <p class="pre">{{ form.shinsei_jiyuu }}</p>
    </div>
    
    <div class="col-item">
      <b class="title">備考</b>
      <p class="pre">{{ form.notes ?? '無し' }}</p>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue'
import { Shinsei } from '@/types/Shinsei';

export default defineComponent({
  props: {
    form: {
      type: Object as () => Shinsei,
      default: null
    },
  },
  setup(props) {

    const kekkin = props.form.kekkin;

    return {
      kekkin,
    }
  },
  components: {

  }
})

</script>
<style lang="scss" scoped>
@import '@scss/components/shinsei-detail.scss';
</style>